import React, { useState } from "react";
import { Button, Card, Col, Form, Row } from "react-bootstrap";
import { useFormContext } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";

const BasicInformation = () => {
  const {
    register,
    formState: { errors },
  } = useFormContext();

  const navigate = useNavigate();
  const { state } = useLocation();

  const [loading, setLoading] = useState(false);
  const maxCharactersLength = 255;

  return (
    <>
      {loading ? (
        <div className="d-flex py-3 justify-content-center align-items-center">
          <Button variant="falcon-default" size="sm" className="fs-10">
            Loading...
          </Button>
        </div>
      ) : (
        <Card.Body
          className=""
          style={{
            height: `calc(100vh - 12.7rem)`,
            overflow: "auto",
            padding: "5px 20px",
          }}
        >
          <Row className="gx-2 pb-2">
            <Col md="6">
              <Form.Group>
                <Form.Control
                  type="text"
                  placeholder="Name"
                  title="Name"
                  maxLength={maxCharactersLength}
                  className="py-2 "
                  isInvalid={!!errors.name}
                  {...register("name")}
                />
                <div className="d-flex justify-content-between align-items-center">
                  <Form.Control.Feedback
                    type="invalid"
                    className="d-inline w-75"
                  >
                    {errors.name?.message}
                  </Form.Control.Feedback>
                </div>
              </Form.Group>
            </Col>
            <Col md="6">
              <Form.Group>
                <Form.Check
                  type="checkbox"
                  id="defaultSwitch"
                  label="Active"
                  className="mt-2"
                  defaultChecked={!state}
                  isInvalid={!!errors.status}
                  {...register("status")}
                />
              </Form.Group>
            </Col>

            <Card.Header as="h6" className="bg-body-tertiary mb-2 mt-2 mx-1">
              Pickup Address
            </Card.Header>
            <Col md="6">
              <Form.Group>
                <Form.Control
                  type="text"
                  placeholder="Contact"
                  title="Contact"
                  maxLength={maxCharactersLength}
                  className="py-2 "
                  isInvalid={!!errors.pickupContact}
                  {...register("pickupContact")}
                />
                <div className="d-flex justify-content-between align-items-center">
                  <Form.Control.Feedback
                    type="invalid"
                    className="d-inline w-75"
                  >
                    {errors.pickupContact?.message}
                  </Form.Control.Feedback>
                </div>
              </Form.Group>
            </Col>
            <Col md="6">
              <Form.Group>
                <Form.Control
                  type="text"
                  placeholder="Phone Number"
                  title="Phone Number"
                  maxLength={maxCharactersLength}
                  className="py-2 "
                  isInvalid={!!errors.pickupPhoneNumber}
                  {...register("pickupPhoneNumber")}
                />
                <div className="d-flex justify-content-between align-items-center">
                  <Form.Control.Feedback
                    type="invalid"
                    className="d-inline w-75"
                  >
                    {errors.pickupPhoneNumber?.message}
                  </Form.Control.Feedback>
                </div>
              </Form.Group>
            </Col>
            <Col md="6">
              <Form.Group>
                <Form.Control
                  type="text"
                  placeholder="Address"
                  title="Address"
                  maxLength={maxCharactersLength}
                  className="py-2 "
                  isInvalid={!!errors.pickupAddress}
                  {...register("pickupAddress")}
                />
                <div className="d-flex justify-content-between align-items-center">
                  <Form.Control.Feedback
                    type="invalid"
                    className="d-inline w-75"
                  >
                    {errors.pickupAddress?.message}
                  </Form.Control.Feedback>
                </div>
              </Form.Group>
            </Col>
            <Col md="6">
              <Form.Group>
                <Form.Control
                  type="text"
                  placeholder="City"
                  title="City"
                  maxLength={maxCharactersLength}
                  className="py-2 "
                  isInvalid={!!errors.pickupCity}
                  {...register("pickupCity")}
                />
                <div className="d-flex justify-content-between align-items-center">
                  <Form.Control.Feedback
                    type="invalid"
                    className="d-inline w-75"
                  >
                    {errors.pickupCity?.message}
                  </Form.Control.Feedback>
                </div>
              </Form.Group>
            </Col>
            <Col md="6">
              <Form.Group>
                <Form.Control
                  type="text"
                  placeholder="State"
                  title="State"
                  maxLength={maxCharactersLength}
                  className="py-2 "
                  isInvalid={!!errors.pickupState}
                  {...register("pickupState")}
                />
                <div className="d-flex justify-content-between align-items-center">
                  <Form.Control.Feedback
                    type="invalid"
                    className="d-inline w-75"
                  >
                    {errors.pickupState?.message}
                  </Form.Control.Feedback>
                </div>
              </Form.Group>
            </Col>
            <Col md="6">
              <Form.Group>
                <Form.Control
                  type="text"
                  placeholder="Country"
                  title="Country"
                  maxLength={maxCharactersLength}
                  className="py-2 "
                  isInvalid={!!errors.pickupCountry}
                  {...register("pickupCountry")}
                />
                <div className="d-flex justify-content-between align-items-center">
                  <Form.Control.Feedback
                    type="invalid"
                    className="d-inline w-75"
                  >
                    {errors.pickupCountry?.message}
                  </Form.Control.Feedback>
                </div>
              </Form.Group>
            </Col>
            <Col md="6">
              <Form.Group>
                <Form.Control
                  type="text"
                  placeholder="Postal Code"
                  title="Postal Code"
                  maxLength={maxCharactersLength}
                  className="py-2 "
                  isInvalid={!!errors.pickupPostalCode}
                  {...register("pickupPostalCode")}
                />
                <div className="d-flex justify-content-between align-items-center">
                  <Form.Control.Feedback
                    type="invalid"
                    className="d-inline w-75"
                  >
                    {errors.pickupPostalCode?.message}
                  </Form.Control.Feedback>
                </div>
              </Form.Group>
            </Col>
            <Card.Header as="h6" className="bg-body-tertiary mb-2 mt-2 mx-1">
              Return Address
            </Card.Header>
            <Col md="6">
              <Form.Group>
                <Form.Control
                  type="text"
                  placeholder="Contact"
                  title="Contact"
                  maxLength={maxCharactersLength}
                  className="py-2 "
                  isInvalid={!!errors.returnContact}
                  {...register("returnContact")}
                />
                <div className="d-flex justify-content-between align-items-center">
                  <Form.Control.Feedback
                    type="invalid"
                    className="d-inline w-75"
                  >
                    {errors.returnContact?.message}
                  </Form.Control.Feedback>
                </div>
              </Form.Group>
            </Col>
            <Col md="6">
              <Form.Group>
                <Form.Control
                  type="text"
                  placeholder="Phone Number"
                  title="Phone Number"
                  maxLength={maxCharactersLength}
                  className="py-2 "
                  isInvalid={!!errors.returnPhoneNumber}
                  {...register("returnPhoneNumber")}
                />
                <div className="d-flex justify-content-between align-items-center">
                  <Form.Control.Feedback
                    type="invalid"
                    className="d-inline w-75"
                  >
                    {errors.returnPhoneNumber?.message}
                  </Form.Control.Feedback>
                </div>
              </Form.Group>
            </Col>
            <Col md="6">
              <Form.Group>
                <Form.Control
                  type="text"
                  placeholder="Address"
                  title="Address"
                  maxLength={maxCharactersLength}
                  className="py-2 "
                  isInvalid={!!errors.returnAddress}
                  {...register("returnAddress")}
                />
                <div className="d-flex justify-content-between align-items-center">
                  <Form.Control.Feedback
                    type="invalid"
                    className="d-inline w-75"
                  >
                    {errors.returnAddress?.message}
                  </Form.Control.Feedback>
                </div>
              </Form.Group>
            </Col>
            <Col md="6">
              <Form.Group>
                <Form.Control
                  type="text"
                  placeholder="City"
                  title="City"
                  maxLength={maxCharactersLength}
                  className="py-2 "
                  isInvalid={!!errors.returnCity}
                  {...register("returnCity")}
                />
                <div className="d-flex justify-content-between align-items-center">
                  <Form.Control.Feedback
                    type="invalid"
                    className="d-inline w-75"
                  >
                    {errors.returnCity?.message}
                  </Form.Control.Feedback>
                </div>
              </Form.Group>
            </Col>
            <Col md="6">
              <Form.Group>
                <Form.Control
                  type="text"
                  placeholder="State"
                  title="State"
                  maxLength={maxCharactersLength}
                  className="py-2 "
                  isInvalid={!!errors.returnState}
                  {...register("returnState")}
                />
                <div className="d-flex justify-content-between align-items-center">
                  <Form.Control.Feedback
                    type="invalid"
                    className="d-inline w-75"
                  >
                    {errors.returnState?.message}
                  </Form.Control.Feedback>
                </div>
              </Form.Group>
            </Col>
            <Col md="6">
              <Form.Group>
                <Form.Control
                  type="text"
                  placeholder="Country"
                  title="Country"
                  maxLength={maxCharactersLength}
                  className="py-2 "
                  isInvalid={!!errors.returnCountry}
                  {...register("returnCountry")}
                />
                <div className="d-flex justify-content-between align-items-center">
                  <Form.Control.Feedback
                    type="invalid"
                    className="d-inline w-75"
                  >
                    {errors.returnCountry?.message}
                  </Form.Control.Feedback>
                </div>
              </Form.Group>
            </Col>
            <Col md="6">
              <Form.Group>
                <Form.Control
                  type="text"
                  placeholder="Postal Code"
                  title="Postal Code"
                  maxLength={maxCharactersLength}
                  className="py-2 "
                  isInvalid={!!errors.returnPostalCode}
                  {...register("returnPostalCode")}
                />
                <div className="d-flex justify-content-between align-items-center">
                  <Form.Control.Feedback
                    type="invalid"
                    className="d-inline w-75"
                  >
                    {errors.returnPostalCode?.message}
                  </Form.Control.Feedback>
                </div>
              </Form.Group>
            </Col>

          </Row>
        </Card.Body>
      )}
    </>
  );
};

export default BasicInformation;
